import { useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { CssBaseline } from "@material-ui/core";
import { SiteContext } from "./contexts/SiteContext";
import { ViewContextProvider } from "./contexts/ViewContext";
import ScrollToTopOnRouteChange from "./ScrollToTopOnRouteChange";

// Pages
import SiteSelect from "./pages/SiteSelect";
import Home from "./pages/Home";
import Page from "./pages/Page";
import Pages from "./pages/Pages";
import Unit from "./pages/Unit";
import Units from "./pages/Units";
import Theme from "./pages/Theme";
import Themes from "./pages/Themes";
import Region from "./pages/Region";
import Regions from "./pages/Regions";
import Entry from "./pages/Entry";
import Entries from "./pages/Entries";
import Person from "./pages/Person";
import People from "./pages/People";
import Search from "./pages/Search";

// 404 page
import NotFound from "./components/NotFound";

// Import the admin app
import Admin from "./admin/App";

function App() {
  const [selectedSite, setSelectedSite] = useState();

  return (
    <Router basename={`${process.env.REACT_APP_BASENAME}`}>
      <ScrollToTopOnRouteChange>
        <CssBaseline />
        <SiteContext.Provider value={{ selectedSite, setSelectedSite }}>
          <ViewContextProvider>
            <Switch>
              <Route path={`/${process.env.REACT_APP_ADMIN_URL}`} component={Admin} />
              <Route exact path="/" component={SiteSelect} />
              <Route exact path="/:siteSlug" component={Home} />
              <Route exact path="/:siteSlug/pages" component={Pages} />
              <Route exact path="/:siteSlug/pages/:pageSlug" component={Page} />
              <Route exact path="/:siteSlug/search/:query" component={Search} />
              <Route exact path="/:siteSlug/units" component={Units} />
              <Route exact path="/:siteSlug/units/:unitSlug" component={Unit} />
              <Route exact path="/:siteSlug/themes" component={Themes} />
              <Route exact path="/:siteSlug/regions" component={Regions} />
              <Route
                exact
                path="/:siteSlug/themes/:themeSlug"
                component={Theme}
              />
              <Route
                exact
                path="/:siteSlug/regions/:regionSlug"
                component={Region}
              />
              <Route
                exact
                path="/:siteSlug/entries/:entrySlug"
                component={Entry}
              />
              <Route exact path="/:siteSlug/entries" component={Entries} />
              <Route
                exact
                path="/:siteSlug/people/:personSlug"
                component={Person}
              />
              <Route exact path="/:siteSlug/people" component={People} />
              {/*Fallback Route*/}
              <Route component={NotFound} />
            </Switch>
          </ViewContextProvider>
        </SiteContext.Provider>
      </ScrollToTopOnRouteChange>
    </Router>
  );
}

export default App;
